/**
 * Legacy admin brand CRUD. Backend v1.3+ single-store builds removed these routes from
 * `/api/v1/dashboard/admin`; prefer `services/rest/brand.js` (public paginate) for pickers.
 * This module is kept for any old imports; brand routes are not mounted in `routes/index.js`.
 */
import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const brandService = {
  get: (params) => request.get('dashboard/admin/brands', { params }),
  getAll: (params) =>
    request.get('dashboard/admin/brands/paginate', { params }),
  export: (params) =>
    requestWithoutTimeout.get('dashboard/admin/brands/export', { params }),
  import: (data) => request.post('dashboard/admin/brands/import', data),
  getById: (id, params) =>
    requestWithoutTimeout.get(`dashboard/admin/brands/${id}`, { params }),
  create: (data) => request.post('dashboard/admin/brands', data),
  update: (id, data) =>
    request.put(`dashboard/admin/brands/${id}`, data),
  delete: (data) =>
    request.delete(`dashboard/admin/brands/delete`, { data }),
  deleteById: (id) => request.delete(`dashboard/admin/brands/${id}`),
  search: (params) => request.get(`dashboard/admin/brands/search`, { params }),
  dropAll: () => request.get(`dashboard/admin/brands/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/brands/restore/all`),
};

export default brandService;
